import { render, staticRenderFns } from "./TickerDetails.vue?vue&type=template&id=664ef6e4&scoped=true&"
import script from "./TickerDetails.vue?vue&type=script&lang=js&"
export * from "./TickerDetails.vue?vue&type=script&lang=js&"
import style0 from "./TickerDetails.vue?vue&type=style&index=0&id=664ef6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ef6e4",
  null
  
)

export default component.exports